import { Box, BoxProps } from "@material-ui/core";
import { useThemeColor } from "@themes/Colors";
import React from "react";
import clsx from 'clsx';

export type PageContentProps = BoxProps & {
}

export function PageContent ({className, ...props}: PageContentProps) {
    const themeColor = useThemeColor();

    return (
        <Box className={clsx(themeColor.component.pageContent, className)} {...props} />
    )
}